import { gql } from "@apollo/client";

export const USER_POOL_GET_CVT_TOKEN = gql`
  query GetTravelCVTToken {
    token: getTravelCVTToken
  }
`;
